import { createBrowserHistory } from 'history';

/**
 * Singleton history exposed to both <Router> and to sagas that need
 * to navigate without component context.
 */
export const history = createBrowserHistory();
